import { Navigate, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import InlineSpinner from "../../Skeleton/InlineSpinner";

export default function ProtectedRoute({
  isAllowed,
  isLoading,
  redirectPath = "/login",
  children,
}) {
  const { t } = useTranslation();

  if (isLoading) {
    // A spinner, not a skeleton: this runs before we know whether the user is
    // even allowed in, so there is no page shape to stand in for.
    return (
      <div className="flex h-full items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
        {/* A column, not `text-center`: the spinner is an inline <svg>, so
            text-align centred the line box it sits in - trailing whitespace
            and all - and left the circle a few pixels off from the word
            underneath it. */}
        <div className="flex flex-col items-center">
          <InlineSpinner
            className="h-12 w-12 text-primary"
            label={t("common.loading")}
          />
          <p className="mt-4 text-gray-600">{t("common.loading")}</p>
        </div>
      </div>
    );
  }

  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
}
